import { useEffect } from 'react'
import { Routes, Route, Navigate } from 'react-router-dom'
import { Toaster } from 'sonner'
import { useAuthStore } from '@/stores/auth'
import { LoginPage } from '@/features/auth/LoginPage'
import { SaaSContractSignPage } from '@/features/contracts/SaaSContractSignPage'
import { DashboardPage } from '@/features/dashboard/DashboardPage'
import { TenantsPage } from '@/features/tenants/TenantsPage'
import { TenantInvitesPage } from '@/features/tenants/TenantInvitesPage'
import { PublicRegistrationPage } from '@/features/tenants/PublicRegistrationPage'
import { TenantDetailPage } from '@/features/tenants/TenantDetailPage'
import { ZapLeadsPage } from '@/features/zapLeads/ZapLeadsPage'
import { PartnerInterestsPage } from '@/features/partners/PartnerInterestsPage'
import { QuotasPage } from '@/features/quotas/QuotasPage'
import { BillingDashboardPage } from '@/features/billing/BillingDashboardPage'
import { PlansPage } from '@/features/billing/PlansPage'
import { Layout } from '@/shared/components/Layout'
import { LoadingScreen } from '@/shared/components/LoadingScreen'

export function App() {
  const { checkAuth, isLoading, isAuthenticated } = useAuthStore()

  useEffect(() => {
    checkAuth()
  }, [checkAuth])

  if (isLoading) {
    return <LoadingScreen />
  }

  return (
    <>
      <Routes>
        {/* Public routes - acessíveis sem autenticação */}
        <Route path="/login" element={<LoginPage />} />
        <Route path="/register" element={<PublicRegistrationPage />} />
        <Route path="/contrato/:uuid" element={<SaaSContractSignPage />} />
        <Route path="/contrato/saas/:uuid" element={<SaaSContractSignPage />} />

        {/* Protected routes */}
        {isAuthenticated ? (
          <Route path="/" element={<Layout />}>
            <Route index element={<Navigate to="/dashboard" replace />} />
            <Route path="dashboard" element={<DashboardPage />} />
            <Route path="tenants" element={<TenantsPage />} />
            <Route path="tenants/invites" element={<TenantInvitesPage />} />
            <Route path="zap-leads" element={<ZapLeadsPage />} />
            <Route path="tenants/:id" element={<TenantDetailPage />} />
            <Route path="partners/interests" element={<PartnerInterestsPage />} />
            <Route path="quotas" element={<QuotasPage />} />
            <Route path="billing" element={<BillingDashboardPage />} />
            <Route path="billing/plans" element={<PlansPage />} />
            <Route path="*" element={<Navigate to="/dashboard" replace />} />
          </Route>
        ) : (
          <>
            {/* Redireciona para login apenas rotas não públicas */}
            <Route path="/" element={<Navigate to="/login" replace />} />
            <Route path="/dashboard" element={<Navigate to="/login" replace />} />
            <Route path="/tenants/*" element={<Navigate to="/login" replace />} />
            <Route path="/zap-leads" element={<Navigate to="/login" replace />} />
            <Route path="/quotas" element={<Navigate to="/login" replace />} />
            <Route path="/billing/*" element={<Navigate to="/login" replace />} />
            <Route path="*" element={<Navigate to="/login" replace />} />
          </>
        )}
      </Routes>

      <Toaster
        position="top-right"
        richColors
        closeButton
        expand={false}
      />
    </>
  )
}
